import { render, staticRenderFns } from "./_view-products.modal.vue?vue&type=template&id=45cb3b1a&scoped=true"
import script from "./_view-products.modal.vue?vue&type=script&lang=js"
export * from "./_view-products.modal.vue?vue&type=script&lang=js"
import style0 from "./_view-products.modal.vue?vue&type=style&index=0&id=45cb3b1a&prod&lang=scss&scoped=true"
import style1 from "./_view-products.modal.vue?vue&type=style&index=1&id=45cb3b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb3b1a",
  null
  
)

export default component.exports